import { createWebHistory, createRouter } from "vue-router";
import redirect from "./redirect";
import masterData from "./masterData";
import attendance from "./attendance";
import account from "./account";
import guest from "./guest";
import workshop from "./workshop";
import rujukan from "./rujukan";
import edukasi from "./edukasi";
import cru from "./cru";
import admin from "./admin";
import ability from "@/plugins/casl/ability";
import { nextTick } from "vue";
import elibrary from "./elibrary";
// import certificate from "./certificate";

const routes = [
    ...redirect,
    ...masterData,
    ...attendance,
    ...account,
    ...guest,
    ...workshop,
    ...rujukan,
    ...edukasi,
    ...elibrary,
    ...cru,
    ...admin,
    {
        path: "/",
        name: "home",
        component: () => import("@/pages/home/HomeNew.vue"),
        meta: {
            pageTitle: "Beranda",
            icon: "icon-[ic--twotone-home]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    
    {
        path: "/participant",
        name: "participant",
        component: () =>
            import("@/pages/masterdata/participant/Participant.vue"),
        meta: {
            pageTitle: "Peserta",
            icon: "icon-[ph--certificate-duotone]",
            layout: "LayoutAdmin",
            resource: "sysdev",
            action: "read",
        },
    },
    {
        path: "/certificate",
        name: "certificate",
        component: () => import("@/pages/certificate/Certificate.vue"),
        meta: {
            pageTitle: "Sertifikat",
            icon: "icon-[ph--certificate-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/gallery",
        name: "gallery",
        component: () => import("@/pages/gallery/Gallery.vue"),
        meta: {
            pageTitle: "Galeri",
            icon: "icon-[tabler--photo]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/surat-menyurat",
        name: "surat-menyurat",
        component: () => import("@/pages/surat-menyurat/SuratMenyurat.vue"),
        meta: {
            pageTitle: "Surat Menyurat",
            icon: "icon-[tabler--file-description]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
];

const router = createRouter({
    // history: createWebHistory(import.meta.env.BASE_URL),
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (from.meta.savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    const hasLogin = ability.can("read", "auth");
    const canNavigate = to.matched.some((route) => {
        if (Array.isArray(route.meta.resource)) {
            let resource = route.meta.resource;
            const result = resource.some((r) => {
                return ability.can(route.meta.action || "read", r);
            });
            return result;
        } else {
            return ability.can(
                route.meta.action || "read",
                route.meta.resource
            );
        }
    });
    if (!canNavigate) {
        return next("/not-authorized");
    }
    if (hasLogin && to.name === "login") {
        next({ name: "home", replace: true });
        return;
    }
    next();
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609

    nextTick().then(() => {
        // window.scrollTo(0, 0);
        document.title =
            to.meta.pageTitle + " - Krisan Edu Health Hub" ||
            "Krisan Edu Health Hub";
    });
});

export default router;
